import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query BlogUrlInstructions($id: ID!) {
    blogUrlInstructions(id: $id) {
      instructions
      status
      extractionErrors
    }
  }
`;

interface Result {
  instructions: string;
  status: string;
  extractionErrors: string[];
}

export const queryBlogUrlInstructions = async (id: ID) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      id,
    },
  });

  return getSingleProp<Result>(result.data);
};
